"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userProfilesResultFactory = void 0;
const Factory = require("factory.ts");
const Accounts_1 = require("../Accounts");
const user_profile_factory_1 = require("./user-profile.factory");
exports.userProfilesResultFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    user: Accounts_1.userFactory.build(),
    profiles: user_profile_factory_1.userProfileFactory.buildList(2),
});
